import { Box, styled } from "@mui/material";

const MetadataContainer = styled(Box)({
    height: '100%',
    minHeight: '60vh',
    display: 'flow',
    position:'relative', 
    '& .choices__list--dropdown': {
        position:'relative'
    }
});

export default MetadataContainer;